import { render } from "./Delete.vue?vue&type=template&id=d35b46a8&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d35b46a8"

export default script